export const PORTAL_RETURN_LABEL_MODAL_FORM = 'portalReturnLabelModalForm'

export const PORTAL_RETURN_LABEL_MAX_DEVICES = 10

export const PORTAL_RETURN_LABEL_ADDRESS_FIELD_MAX_LENGTH = 100
